<template>
  <div class="card shadow-sm">
    <div class="card-body py-5 px-md-5">
      <h2 class="mb-5 d-flex align-items-center">
        <slot></slot>
        <span>Formas de pago</span>
      </h2>
      <div class="row">
        <div class="col-12">
          <PayMethods v-model="formPay" :mixedShow="true" :couponFree="couponFree" :saleType="saleType"></PayMethods>
          <SummaryDelivery @returnAddress="$emit('returnAddress')" v-if="isDeliveryProccess" />
        </div>
        <div class="col-12 mb-4" v-if="formPay.type === 'multiple'">
          <div class="row m-0 pt-4 border rounded-bottom">
            <div class="col-6">
              <div class="form-group row">
                <label for="staticEmail" class="col-sm-5 col-form-label">Tipo POS</label>
                <div class="col-sm-7 py-2">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      v-model="mixed.card"
                      id="mixedPos1"
                      value="visa"
                    />
                    <label class="form-check-label" for="mixedPos1">Visa</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      v-model="mixed.card"
                      id="mixedPos2"
                      value="mastercard"
                    />
                    <label class="form-check-label" for="mixedPos2">Mastercard</label>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="inputCode" class="col-sm-5 col-form-label">Código POS</label>
                <div class="col-sm-7 ml-auto">
                  <input
                    id="inputCode"
                    v-model="mixed.code"
                    type="text"
                    class="form-control"
                    placeholder="código pos"
                  />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group row">
                <label for="inputAmount" class="col-sm-5 col-form-label">Total POS</label>
                <div class="col-sm-7">
                  <span class="mr-3">{{ productsMeta.currency }}</span>
                  <input
                    id="inputAmount"
                    v-model="mixed.amount"
                    type="number"
                    class="form-control d-inline-block"
                    placeholder="Monto pos"
                    style="width: 80%"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="inputCash" class="col-sm-5 col-form-label">Total Efectivo</label>
                <div class="col-sm-7">
                  <span class="mr-3">{{ productsMeta.currency }}</span>
                  <input
                    id="inputCash"
                    v-model="mixed.cash"
                    type="number"
                    class="form-control d-inline-block"
                    placeholder="Monto efectivo"
                    style="width: 80%"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="cashReturn" class="col-sm-5 col-form-label">Vuelto</label>
                <div class="col-sm-7">
                  <span :class="`mr-3 ${remaining < 0 ? 'text-danger' : ''}`">
                    {{ productsMeta.currency }}
                  </span>
                  <input
                    id="cashReturn"
                    type="text"
                    readonly
                    :class="`form-control-plaintext d-inline-block ${
                      remaining < 0 ? 'text-danger' : ''
                    }`"
                    v-model="remaining"
                    style="width: 78%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 my-4" v-if="!isDeliveryProccess">
          <table class="table w-50 ml-auto">
            <tbody>
              <tr v-if="productsMeta.discount > 0" class="text-right">
                <td class="border-0"><b>SubTotal:</b></td>
                <td class="border-0 h4">
                  {{ productsMeta.currency }}
                  {{ productsMeta.subtotal.toFixed(2) }}
                </td>
              </tr>
              <tr v-if="productsMeta.discount > 0" class="text-right">
                <td class="border-0"><b>Descuento:</b></td>
                <td class="border-0 h4">
                  {{ productsMeta.currency }} -{{ productsMeta.discount }}
                </td>
              </tr>
              <tr class="text-right">
                <td class="border-0"><b>Total:</b></td>
                <td class="border-0 h4">{{ productsMeta.currency }} {{ productsMeta.total }}</td>
              </tr>
              <tr v-if="formPay.type === 'efectivo' && couponFree" class="text-right">
                <td class="border-0"><b>Efectivo:</b></td>
                <td class="border-0 h4">
                  <input
                    v-model="cash"
                    type="number"
                    class="form-control"
                    placeholder="Efectivo Soles"
                    style="width: 160px; margin-left: auto"
                  />
                </td>
              </tr>
              <tr v-if="formPay.type === 'efectivo' && couponFree" class="text-right">
                <td class="border-0"><b>Vuelto:</b></td>
                <td class="border-0 h4">{{ productsMeta.currency }} {{ onChangeCash }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Procceso de delivery -->
        <div class="col-12 my-4" v-else>
          <table class="table w-50 ml-auto">
            <tbody>
              <tr class="text-right">
                <td class="border-0" v-if="isHomeDelivery"><b>SubTotal:</b></td>
                <td class="border-0" v-else><b>Total:</b></td>
                <td class="border-0 h4">
                  {{ productsMeta.currency }}
                  {{ productsMeta.subtotal.toFixed(2) }}
                </td>
              </tr>
              <tr class="text-right" v-if="isHomeDelivery">
                <td class="border-0"><b>Delivery:</b></td>
                <td class="border-0 h4">{{ productsMeta.currency }} {{ deliveryCost }}</td>
              </tr>
              <tr class="text-right" v-if="isHomeDelivery">
                <td class="border-0"><b>Total:</b></td>
                <td class="border-0 h4">{{ productsMeta.currency }} {{ isTotalDelivery }}</td>
              </tr>
              <tr class="text-right" v-if="formPay.type === 'efectivo'">
                <td class="border-0"><b>Efectivo:</b></td>
                <td class="border-0 h4">
                  <input
                    v-model="cash"
                    type="number"
                    class="form-control"
                    placeholder="Efectivo Soles"
                    style="width: 160px; margin-left: auto"
                  />
                </td>
              </tr>
              <tr class="text-right" v-if="formPay.type === 'efectivo'">
                <td class="border-0"><b>Vuelto:</b></td>
                <td class="border-0 h4">{{ productsMeta.currency }} {{ onChangeCash }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Fin Procceso de delivery -->
        <div class="col-12 col-md-5 col-lg-4 ml-auto">
          <button
            @click="register()"
            type="submit"
            :disabled="
              (formPay.type === 'pos' && !formPay.code) ||
              loading ||
              (formPay.type === 'efectivo' && onChangeCash < 0) ||
              (formPay.type === 'efectivo' && !cash && couponFree) ||
              (formPay.type === 'multiple' && remaining < 0) ||
              (formPay.type === 'multiple' && !mixed.code) ||
              (formPay.type === 'multiple' && !mixed.cash)
            "
            class="btn btn-action btn-lg btn-block"
          >
            <span>Registrar pago</span>
          </button>
        </div>
        <div v-if="errors.length" class="col-12 text-center mt-3">
          <div v-for="(err, idx) in errors" :key="idx" class="text-danger">
            {{ err }}
          </div>
        </div>
        <div v-if="loading" class="col-12 pt-4">
          <div class="d-flex align-items-center justify-content-end">
            <b-spinner label="Busy"></b-spinner>
            <b class="ml-3">Registrando pago...</b>
          </div>
        </div>
      </div>

      <b-modal
        v-model="modalConfirm"
        hide-header
        cancel-title="Cerrar"
        ok-title="Confirmar"
        ok-variant="action btn-lg ml-3"
        @ok="submit()"
      >
        <div class="mt-3">
          <h3 v-if="!isHomeDelivery">
            Total a pagar {{ productsMeta.currency }} {{ productsMeta.total }}
          </h3>
          <h3 v-else>Total a pagar {{ productsMeta.currency }} {{ isTotalDelivery }}</h3>
          <p class="ml-1">
            Forma de pago:
            <b>{{ formPay.type }}</b>
            <b v-if="formPay.type === 'pos'"> - {{ formPay.card }} </b>
          </p>
          <p class="lead">¿Estás segur@ que la información es correcta?</p>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import api from '../../api';

export default {
  props: {
    transaction: Object,
    user: Object,
    saleType:  {
      type: String,
      default() {
        return {
          saleType: 'product'
        };
      }
    },
    couponFree: {
      type: Boolean,
      default() {
        return {
          couponFree: false
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      modalConfirm: false,
      formPay: {
        type: 'efectivo',
        card: null,
        code: null
      },
      mixed: {
        card: 'visa',
        code: '',
        amount: '',
        cash: '',
        amountCash: '',
        cashReturned: ''
      },
      errors: [],
      cash: null
    };
  },
  computed: {
    userBilling() {
      return this.$store.state.billing.userBilling;
    },
    auth() {
      return this.$store.state.auth;
    },
    products() {
      return this.$store.getters.cartProducts;
    },
    productsMeta() {
      return this.$store.getters.cartProductsMeta;
    },
    couponProducts() {
      const couponAux = this.$store.state.cart.couponProducts;
      const coupon = [];

      Object.values(couponAux).forEach((el) => {
        if (el.active) {
          coupon.push({ code: el.code });
        }
      });

      return coupon;
    },
    isTotalDelivery() {
      return parseFloat(this.productsMeta.total) + this.deliveryCost;
    },
    onChangeCash() {
      let cashReturn = '';
      if (this.isDeliveryProccess) {
        cashReturn = parseFloat(this.cash) - parseFloat(this.isTotalDelivery);
      } else {
        cashReturn = parseFloat(this.cash) - parseFloat(this.productsMeta.total);
      }

      return cashReturn ? cashReturn.toFixed(2) : 0;
    },
    remaining() {
      const cash = this.mixed.cash ? this.mixed.cash : 0;
      const amount = this.mixed.amount ? this.mixed.amount : 0;
      const amountTotal = parseFloat(amount) + parseFloat(cash);
      return (amountTotal - parseFloat(this.productsMeta.total)).toFixed(2);
    },
    isDeliveryProccess() {
      return this.$store.getters.getIsDeliveryProccess;
    },
    deliveryCost() {
      return parseFloat(this.$store.getters.getCost);
    },
    delivery() {
      return this.$store.getters.delivery;
    },
    isHomeDelivery() {
      return this.$store.getters.isHomeDelivery;
    }
  },
  methods: {
    register() {
      this.modalConfirm = true;
    },
    async submit() {
      this.loading = true;
      const { eventId } = this.$route.params;
      let cashReturn = this.onChangeCash;
      let cashAux = this.cash ? this.cash : 0;
      if (this.formPay.type === 'multiple') {
        this.mixed.amountCash = (
          parseFloat(this.productsMeta.total) - parseFloat(this.mixed.amount)
        ).toFixed(2);
        this.formPay.mixed = this.mixed;
        cashAux = this.mixed.cash;
        cashReturn = this.remaining;
      } else {
        this.formPay.amount = this.productsMeta.total;
      }

      if (this.isDeliveryProccess && this.isHomeDelivery) {
        this.formPay.amount = this.isTotalDelivery;
        this.delivery.isDeliveryProccess = this.isDeliveryProccess;
      }

      const isBilling = Boolean(this.userBilling.businessIdentifier);
      let user = { ...this.user };
      if (isBilling) {
        user.documentType = 'RUC';
        user.document = this.userBilling.businessIdentifier;
      }
      let transaction = { ...this.transaction };
      if (isBilling) {
        transaction.isInvoice = true;
        transaction.socialReason = this.userBilling.businessName;
        transaction.address = this.userBilling.address;
      }
      const { success, data, errors } = await api.reservateAndPayProducts(
        this.products,
        user,
        this.formPay,
        eventId,
        this.couponProducts,
        cashAux,
        cashReturn,
        transaction,
        this.delivery
      );

      this.loading = false;
      if (!success) {
        this.errors = errors;
        setTimeout(() => {
          this.errors = [];
        }, 6000);
      } else {
        this.$emit('on-pay', { data, formPay: this.formPay });
      }
    },
  }
};
</script>
